import { Link, NavLink } from "react-router-dom";
import { ShoppingBag } from "lucide-react";
import { Logo } from "@/components/brand/Logo";
import { BookAppointment } from "@/components/common/BookAppointment";
import { useCart } from "@/context/CartContext";
import { useSite } from "@/context/SiteContext";
import { NAV_LINKS } from "@/data/copy";
import { MobileNav } from "./MobileNav";

const linkClass = ({ isActive }) =>
  `rounded-full px-3.5 py-2 text-[15px] font-medium transition-colors ${
    isActive ? "bg-gradient-to-r from-brand-tint2 to-brand-skyTint font-semibold text-brand-blue" : "text-slate-700 hover:bg-brand-tint hover:text-brand-blue"
  }`;

const CartButton = () => {
  const { count, setOpen } = useCart();
  return (
    <button
      type="button"
      onClick={() => setOpen(true)}
      data-testid="header-cart-btn"
      aria-label={`Open cart, ${count} item${count === 1 ? "" : "s"}`}
      className="relative flex h-11 w-11 items-center justify-center rounded-full text-brand-ink transition-colors hover:bg-brand-tint"
    >
      <ShoppingBag className="h-5 w-5" aria-hidden="true" />
      {count > 0 && (
        <span data-testid="header-cart-count" className="absolute -right-0.5 -top-0.5 flex h-5 min-w-5 items-center justify-center rounded-full bg-brand-greenDark px-1 text-xs font-bold text-white">
          {count}
        </span>
      )}
    </button>
  );
};

export const Header = () => {
  const { settings } = useSite();
  return (
  <header className="sticky top-0 z-40 border-b border-slate-200/70 bg-white/90 backdrop-blur-xl">
    <div className="absolute inset-x-0 top-0 h-1 bg-gradient-to-r from-brand-sky via-brand-green to-brand-coral" aria-hidden="true" />
    <div className="container-x flex h-16 items-center gap-3 lg:h-20">
      <Link to="/" data-testid="header-logo-link" aria-label="Young Spine Tricity – home" className="shrink-0">
        <Logo className="h-9 w-auto sm:h-11 lg:h-12" />
      </Link>
      <nav aria-label="Main" className="ml-auto hidden items-center gap-0.5 xl:flex">
        {NAV_LINKS.map((l) => (
          <NavLink key={l.to} to={l.to} end={l.to === "/"} className={linkClass} data-testid={`nav-${l.label.toLowerCase().replace(/[^a-z]+/g, "-")}`}>
            {l.label}
          </NavLink>
        ))}
      </nav>
      <div className="ml-auto flex items-center gap-1.5 xl:ml-3">
        <BookAppointment testid="header-book" size="sm" className="hidden sm:inline-flex" />
        {settings.online_payments_enabled && <CartButton />}
        <MobileNav />
      </div>
    </div>
  </header>
  );
};
